import { render, staticRenderFns } from "./IdeaScoreProgressCard.vue?vue&type=template&id=17c329a0&scoped=true"
import script from "./IdeaScoreProgressCard.vue?vue&type=script&lang=js"
export * from "./IdeaScoreProgressCard.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreProgressCard.vue?vue&type=style&index=0&id=17c329a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c329a0",
  null
  
)

export default component.exports